import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login() {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(email, password);
      } else {
        await register(email, password, name);
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Ein Fehler ist aufgetreten');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '420px', margin: '4rem auto', padding: '0 1rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <div style={{ fontSize: '3rem' }}>📚</div>
        <h1 style={{ color: '#4c51bf', marginTop: '0.5rem' }}>Vocabia</h1>
        <p style={{ color: '#718096' }}>Dein persönlicher Vokabeltrainer</p>
      </div>

      <div className="card">
        <div style={{ display: 'flex', marginBottom: '1.5rem', background: '#f0f4f8', borderRadius: '8px', padding: '4px' }}>
          <button
            onClick={() => setMode('login')}
            style={{
              flex: 1, border: 'none', borderRadius: '6px', padding: '0.5rem',
              background: mode === 'login' ? 'white' : 'transparent',
              color: mode === 'login' ? '#4c51bf' : '#718096',
              fontWeight: mode === 'login' ? '600' : '400',
              boxShadow: mode === 'login' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
              cursor: 'pointer'
            }}>
            Anmelden
          </button>
          <button
            onClick={() => setMode('register')}
            style={{
              flex: 1, border: 'none', borderRadius: '6px', padding: '0.5rem',
              background: mode === 'register' ? 'white' : 'transparent',
              color: mode === 'register' ? '#4c51bf' : '#718096',
              fontWeight: mode === 'register' ? '600' : '400',
              boxShadow: mode === 'register' ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
              cursor: 'pointer'
            }}>
            Registrieren
          </button>
        </div>

        {mode === 'register' && (
          <input
            type="text"
            placeholder="Dein Name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        )}

        <input
          type="email"
          placeholder="E-Mail Adresse"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />

        <input
          type="password"
          placeholder="Passwort (min. 6 Zeichen)"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        />

        {error && (
          <div className="message message-error">{error}</div>
        )}

        <button className="btn-primary" style={{ width: '100%' }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Bitte warten...' : mode === 'login' ? 'Anmelden' : 'Konto erstellen'}
        </button>
		
		{mode === 'login' && (
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <Link to="/forgot-password" style={{ color: '#4c51bf', fontSize: '0.9rem' }}>
              Passwort vergessen?
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;